import {ReactElement} from "react";
import {SectionContainer} from "./SharedComponents";
import {StyledBoxColumn, StyledHeadingVariant} from "@/shared/StyledComponents";
import {Button, Typography, useMediaQuery, useTheme} from "@mui/material";
import {BORDER_RADIUS_LARGE, PD_LG, PD_XLG, PD_XLG2} from "@/shared/dimens";
import {PromoSectionData, SiteTemplate} from "../../types";

export function PromoSection(props: { data: PromoSectionData, template: SiteTemplate }): ReactElement {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.up("sm"));

  const imagePane = <div style={{flex: 1, minWidth: 280}}>
    <img
      src={props.data.imageUrl}
      style={{
        width: "100%",
        aspectRatio: 1.6,
        objectFit: "cover",
        borderRadius: BORDER_RADIUS_LARGE,
        display: "block",
      }}/>
  </div>;

  const textPane = <StyledBoxColumn style={{
    flex: 1,
    minWidth: 280,
    justifyContent: "center",
    gap: PD_LG,
    padding: sm ? PD_XLG2 : PD_LG,
  }}>
    {props.data.eyebrow
      ? <Typography
        variant="overline"
        style={{letterSpacing: 2, fontWeight: "600", color: theme.palette.primary.main}}>
        {props.data.eyebrow}
      </Typography>
      : null}
    <StyledHeadingVariant default_={2}>
      {props.data.title}
    </StyledHeadingVariant>
    {props.data.body
      ? <Typography style={{opacity: 0.65, lineHeight: 1.8}}>
        {props.data.body}
      </Typography>
      : null}
    {props.data.link?.text
      ? <Button href={props.data.link.url} variant="contained" style={{alignSelf: "flex-start"}}>
        {props.data.link.text}
      </Button>
      : null}
  </StyledBoxColumn>;

  const imageLeft = !sm || props.data.imagePosition === "left";

  return <div style={{width: "100%", background: props.template.themeExtras.highlightColor}}>
    <SectionContainer>
      <div style={{display: "flex", flexWrap: "wrap", gap: PD_XLG, alignItems: "center"}}>
        {imageLeft ? <>{imagePane}{textPane}</> : <>{textPane}{imagePane}</>}
      </div>
    </SectionContainer>
  </div>;
}
